<template>
  <!-- <pre v-if="responseData"> testData={{ GraphData }}</pre> -->
  <div v-if="responseData">
    <div class="content-wrapper">
      <!-- <h2>PROGRAM KAWALAN TIKUS</h2>
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedMonth"
            label="Bulan"
            :items="months"
            placeholder="Pilih Bulan"
            chips
            class="app-date-picker"
          />
        </div> 
       

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div> -->

      <h2>AKTIVITI KAWALAN TIKUS</h2>
      <div class="vektor">
        <!-- First Image -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Jumlah Aktiviti Dijalankan</h3>
              <p class="number">
                {{ numberWithCommas(bilanganAktiviti) ?? 0 }}
              </p>
            </div>
          </div>
        </div>

        <!-- Second Image -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Jumlah Tikus Ditangkap</h3>
              <p class="number">
                {{ numberWithCommas(bilanganTikus) ?? 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <h2>AKTIVITI KAWALAN TIKUS MENGIKUT PREMIS</h2>
      <div class="chart-wrapper"> 
        <DoubleBar 
          :chart-data="PremisData"
          :chart-categories="PremisNames"
          :legend-labels="['Aktiviti Dijalankan', 'Tikus Ditangkap']"
          :series-colors="['#029708', '#FF0000']"
        />
      </div>

      <h2>AKTIVITI KAWALAN TIKUS SEPANJANG TAHUN</h2>
      <div class="chart-wrapper"> 
        <DoubleBar 
          :chart-data="TikusData1"
          :chart-categories="months.slice(1)"
          :legend-labels="['Jumlah Aktiviti Dijalankan', 'Jumlah Tikus Ditangkap']"
          :series-colors="['#029708', '#FF0000']"
        />
      </div> 

     
      <Update />
      <PrimaryModule />
      <KesihatanPersekitaran />
    </div>
  </div>
</template>

<script setup>
import { useHttpService } from "@/httpService"
import { onMounted, ref, toRaw, watch } from 'vue'


definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const years = ref([])

const months = ref([
  "Semua Bulan",  
  "Januari",
  "Februari",
  "Mac",
  "April",
  "Mei",
  "Jun", 
  "Julai",
  "Ogos",
  "September",
  "Oktober",
  "November",
  "Disember",
])


const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)

// const selectedMonth = ref('Januari') 

const selectedMonth = ref('Semua Bulan') 

const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)
const GraphData = ref(null)
const data =  ref([])

const bilanganAktiviti1 = ref(0)
const bilanganTikus1 = ref(0)

const bilanganAktiviti = ref(0)
const bilanganTikus = ref(0)

const TikusData = ref([])
const TikusData1 = ref([])

const PremisData = ref([])
const PremisNames = ref([])

const GraphData2 = ref([])
const GraphData3 = ref([])

async function loadDataFromApi(month = selectedMonth.value, year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {
    const plainStates = toRaw(state)

    // Start query string
    let queryParams = `year=${year}`

    // Handle month — if "Semua Bulan", use `all`, else use index
    const monthIndex = months.value.indexOf(month)
    queryParams += month === "Semua Bulan" ? `&month=all` : `&month=${monthIndex}`

    // Append states if not "Semua Negeri"
    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    // Append councils if not "Semua PBT"
    if (Array.isArray(pbtValue) && !pbtValue.includes("Semua PBT")) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // Construct final URL (just use queryParams once)
    const url = `kesihatan-persekitaran/vektor/program-kawalan-tikus?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years

    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response
    data.value = responseData.value.data.data

    console.log("Fetched Data:", data.value)

    function safeNumber(value) {
      return isNaN(value) ? 0 : Number(value)
    }

    bilanganAktiviti.value = [
      safeNumber(data.value.bilangan_aktiviti_dijalankan_pusat_penjaja),
      safeNumber(data.value.bilangan_aktiviti_dijalankan_pusat_pelancongan),
      safeNumber(data.value.bilangan_aktiviti_dijalankan_pasar),
      safeNumber(data.value.bilangan_aktiviti_dijalankan_tempat_sampah),
      safeNumber(data.value.bilangan_aktiviti_dijalankan_premis_makanan),
      safeNumber(data.value.bilangan_aktiviti_dijalankan_pelupusan_sampah),
      safeNumber(data.value.bilangan_aktiviti_dijalankan_premis_perniagaan),
      safeNumber(data.value.bilangan_aktiviti_dijalankan_tempat_awam),
      safeNumber(data.value.bilangan_aktiviti_dijalankan_lain_lain),
    ].reduce((total, value) => total + value, 0)

    bilanganTikus.value = [
      safeNumber(data.value.bilangan_tikus_ditangkap_pusat_penjaja),
      safeNumber(data.value.bilangan_tikus_ditangkap_pusat_pelancongan),
      safeNumber(data.value.bilangan_tikus_ditangkap_pasar),
      safeNumber(data.value.bilangan_tikus_ditangkap_tempat_sampah),
      safeNumber(data.value.bilangan_tikus_ditangkap_premis_makanan),
      safeNumber(data.value.bilangan_tikus_ditangkap_pelupusan_sampah),
      safeNumber(data.value.bilangan_tikus_ditangkap_premis_perniagaan),
      safeNumber(data.value.bilangan_tikus_ditangkap_tempat_awam),
      safeNumber(data.value.bilangan_tikus_ditangkap_lain_lain),
    ].reduce((total, value) => total + value, 0)

    PremisNames.value = [
      "Pusat Penjaja",
      "Pusat Pelancongan",
      "Pasar",
      "Tempat Sampah",
      "Premis Makanan",
      "Pelupusan Sampah",
      "Premis Perniagaan",
      "Tempat Awam",
      "Lain-Lain",
    ]

    PremisData.value = [
      [
        safeNumber(data.value.bilangan_aktiviti_dijalankan_pusat_penjaja),
        safeNumber(data.value.bilangan_aktiviti_dijalankan_pusat_pelancongan),
        safeNumber(data.value.bilangan_aktiviti_dijalankan_pasar),
        safeNumber(data.value.bilangan_aktiviti_dijalankan_tempat_sampah),
        safeNumber(data.value.bilangan_aktiviti_dijalankan_premis_makanan),
        safeNumber(data.value.bilangan_aktiviti_dijalankan_pelupusan_sampah),
        safeNumber(data.value.bilangan_aktiviti_dijalankan_premis_perniagaan),
        safeNumber(data.value.bilangan_aktiviti_dijalankan_tempat_awam),
        safeNumber(data.value.bilangan_aktiviti_dijalankan_lain_lain),
      ],
      [
        safeNumber(data.value.bilangan_tikus_ditangkap_pusat_penjaja),
        safeNumber(data.value.bilangan_tikus_ditangkap_pusat_pelancongan),
        safeNumber(data.value.bilangan_tikus_ditangkap_pasar),
        safeNumber(data.value.bilangan_tikus_ditangkap_tempat_sampah),
        safeNumber(data.value.bilangan_tikus_ditangkap_premis_makanan),
        safeNumber(data.value.bilangan_tikus_ditangkap_pelupusan_sampah),
        safeNumber(data.value.bilangan_tikus_ditangkap_premis_perniagaan),
        safeNumber(data.value.bilangan_tikus_ditangkap_tempat_awam),
        safeNumber(data.value.bilangan_tikus_ditangkap_lain_lain),
      ],
    ]
  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}



async function loadDataFromApiYear(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    GraphData.value = []
    GraphData2.value = []
    GraphData3.value = []

    const plainStates = toRaw(state)


    let queryParams = `year=${year}`

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes("Semua PBT")) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }


    const urls = Array.from({ length: 12 }, (_, i) => 
      `kesihatan-persekitaran/vektor/program-kawalan-tikus?year=${year}&month=${i + 1}${queryParams}`,
    )


    const responses = await Promise.all(urls.map(url => httpGet(url)))


    responses.forEach((response, monthIndex) => {
      if (response && response.data && response.data.data) {
        const data = response.data.data


        const bilanganAktiviti1 = [
          safeNumber(data.bilangan_aktiviti_dijalankan_pusat_penjaja),
          safeNumber(data.bilangan_aktiviti_dijalankan_pusat_pelancongan),
          safeNumber(data.bilangan_aktiviti_dijalankan_pasar),
          safeNumber(data.bilangan_aktiviti_dijalankan_tempat_sampah),
          safeNumber(data.bilangan_aktiviti_dijalankan_premis_makanan),
          safeNumber(data.bilangan_aktiviti_dijalankan_pelupusan_sampah),
          safeNumber(data.bilangan_aktiviti_dijalankan_premis_perniagaan),
          safeNumber(data.bilangan_aktiviti_dijalankan_tempat_awam),
          safeNumber(data.bilangan_aktiviti_dijalankan_lain_lain),
        ].reduce((total, value) => total + value, 0)

        const bilanganTikus1 = [
          safeNumber(data.bilangan_tikus_ditangkap_pusat_penjaja),
          safeNumber(data.bilangan_tikus_ditangkap_pusat_pelancongan),
          safeNumber(data.bilangan_tikus_ditangkap_pasar),
          safeNumber(data.bilangan_tikus_ditangkap_tempat_sampah),
          safeNumber(data.bilangan_tikus_ditangkap_premis_makanan),
          safeNumber(data.bilangan_tikus_ditangkap_pelupusan_sampah),
          safeNumber(data.bilangan_tikus_ditangkap_premis_perniagaan),
          safeNumber(data.bilangan_tikus_ditangkap_tempat_awam),
          safeNumber(data.bilangan_tikus_ditangkap_lain_lain),
        ].reduce((total, value) => total + value, 0)


        GraphData2.value.push(bilanganAktiviti1)
        GraphData3.value.push(bilanganTikus1)
      } else {
        console.warn(`No valid data for month ${monthIndex + 1}`)
        GraphData2.value.push(0)
        GraphData3.value.push(0) 
      }
    })


    GraphData.value.push(GraphData2.value, GraphData3.value)
    TikusData1.value = GraphData.value


    function safeNumber(value) {
      return isNaN(value) ? 0 : Number(value)
    }
  } catch (err) {
    console.error("loadDataFromApiYear failed:", err)
  }
}


function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
  loadDataFromApiYear()
  
})


watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedMonth, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedMonth.value, selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })

watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApiYear(selectedYear.value, selectedsState.value, selectedPbt.value)
})
</script>


<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; 
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px; 
  background-color: rgba(255, 255, 255, 65%); 
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%); 
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}



.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}

.input-item:last-child {
  margin-right: 0;
}



h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
}

.title-main {
  color: darkblue;
  font-size: 2rem;
  font-weight: bold;
  margin-block-end: 20;
  text-align: center;
}


.vektor {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px;
}

.vektor-container {
  width: 48%;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}


.activity-box {
  position: relative;
  display: inline-block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}


.box-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}

.box-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #150069;
}

.box-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #a80000;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* This ensures 4 equal-width boxes */
  gap: 30px; /* Adjust the spacing between the boxes */
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1400px;
  margin-top: 40px;
}
</style>
